import { NO_REGULATION_DESCRIIPTION, NO_REGULATION_TITLE } from '@config/constants';
import { Heading } from '../../Heading/Heading';
import { Text } from '../../Text/Text';

export const NoRegulations = () => (
  <>
    <Heading as="span" color="abyss" variant="xs">
      {NO_REGULATION_TITLE}
    </Heading>
    <Text className="text-abyss" variant="md">
      {NO_REGULATION_DESCRIIPTION}
    </Text>
  </>
);
